import { API_URL } from './apiUrl';

export async function deleteAccount(idToken) {
  const response = await fetch(`${API_URL}/delete-account`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`,
    },
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || data.message || 'Failed to delete account');
  }

  return data;
}
